export default __webpack_public_path__ + "static/media/ministerstwo-sportu.21d792be.png";